import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';

import { appActions } from 'app/app.actions';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { CommandName } from 'utils/commands';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { TopbarButton } from '../topbarButton';

export const CommandLauncherTopbarButton = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const openCommandLauncher = useCallback(() => {
    ampli.commandExecuted({
      commandName: 'app:commandLauncher' satisfies CommandName,
      location: 'topbar',
    });

    dispatch(appActions.showModal({ modal: { type: 'app:commandLauncher' } }));
  }, [dispatch]);

  const tooltip = (
    <CommandKeybindingsTooltipContent commandName="app:commandLauncher">
      Command Launcher
    </CommandKeybindingsTooltipContent>
  );

  return (
    <TopbarButton
      onClick={openCommandLauncher}
      icon="bolt"
      tooltip={tooltip}
      data-cmdk-details-expand-helper
    />
  );
};
